@if(ruleForm()){
<form [formGroup]="ruleForm()">
    <!-- Brand Form -->
    <div class="form-group row mb-3">
        <label class="col-md-4 col-form-label">Código</label>
        <div class="col-md-8">
             @if(mode() == formMode.CREATE){
                <input type="text" class="form-control" formControlName="code">
                @if(ruleForm().get('code')?.errors?.required &&
                ruleForm().get('code').touched){
                <div><small class="text-danger">Código es requerido.</small></div>
                }
                }@else{
                <div class="form-group">
                    <strong>{{ruleForm().get('code')?.value}}</strong>
                </div>
                }
        </div>
    </div>
    <div class="form-group row mb-3">
        <label class="col-md-4 col-form-label">Descripción</label>
        <div class="col-md-8">
             @if(mode() == formMode.CREATE || mode() == formMode.EDIT){
                <input type="text" class="form-control" formControlName="description">
                @if(ruleForm().get('description')?.errors?.required &&
                ruleForm().get('description').touched){
                <div><small class="text-danger">Descripción es requerida.</small></div>
                }
                }@else{
                <div class="form-group">
                    <strong>{{ruleForm().get('description')?.value}}</strong>
                </div>
                }
        </div>
    </div>
    
    <div class="form-group row mb-3">
        <label class="col-md-4 col-form-label">Valor</label>
        <div class="col-md-8">
             @if(mode() == formMode.CREATE || mode() == formMode.EDIT){
                <input type="number" class="form-control" formControlName="value">
                @if(ruleForm().get('value')?.errors?.required &&
                ruleForm().get('value').touched){
                <div><small class="text-danger">Valor es requerido.</small></div>
                }
                }@else{
                <div class="form-group">
                    <strong>{{ruleForm().get('value')?.value}}</strong>
                </div>
                }
        </div>
    </div>

    <div class="form-group row mb-3">
        <label class="col-md-4 col-form-label">Rango Min</label>
        <div class="col-md-8">
             @if(mode() == formMode.CREATE || mode() == formMode.EDIT){
                <input type="number" class="form-control" formControlName="minRange">
             }@else{
                <div class="form-group">
                    <strong>{{ruleForm().get('minRange')?.value}}</strong>
                </div>
             }
        </div>
    </div>
    
    <div class="form-group row mb-3">
        <label class="col-md-4 col-form-label">Rango Max</label>
        <div class="col-md-8">
             @if(mode() == formMode.CREATE || mode() == formMode.EDIT){
                <input type="number" class="form-control" formControlName="maxRange">
             }@else{
                <div class="form-group">
                    <strong>{{ruleForm().get('maxRange')?.value}}</strong>
                </div>
             }
        </div>
    </div>
    
    <div class="form-group row mb-3">
        <label class="col-md-4 col-form-label">Tipo Valor</label>
        <div class="col-md-8">
             @if(mode() == formMode.CREATE || mode() == formMode.EDIT){
                <input type="text" class="form-control" formControlName="typeValue">
             }@else{
                <div class="form-group">
                    <strong>{{ruleForm().get('typeValue')?.value}}</strong>
                </div>
             }
        </div>
    </div>


</form>
<ng-content><!-- contenido adicional por el padre --> </ng-content>
}